import client from './client';

export const mediaApi = {
  list: (params) => client.get('/media', { params }).then((r) => r.data),
  upload: (formData) =>
    client
      .post('/media/upload', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
      .then((r) => r.data),
  remove: (id) => client.delete(`/media/${id}`).then((r) => r.data),
  // Re-read an image and regenerate its description + tags. Uploads trigger
  // this automatically; this is the retry, and the way to describe images that
  // predate the feature.
  analyze: (id) => client.post(`/media/${id}/analyze`).then((r) => r.data),
  // Copy a remote image (premium/stock) into the user's own library.
  importUrl: (payload) => client.post('/media/import', payload).then((r) => r.data),
  // Shared premium gallery (admin-curated), available to all users.
  premium: (params) => client.get('/premium-images', { params }).then((r) => r.data),
  premiumCategories: () => client.get('/premium-images/categories').then((r) => r.data),
};

// Free stock image search (Pixabay / Pexels).
export const stockApi = {
  search: (params) => client.get('/stock/search', { params }).then((r) => r.data),
};

export default mediaApi;
